import Vue from "vue";

/**
 * @typedef Image
 *
 * @property {string} directory
 * @property {string} filename
 *
 */

/**
 * @typedef Crop
 */

/**
 * Generats thumbnail image from given parameters
 *
 * @param {Image} image
 * @param {number} width
 * @param {number} height
 * @param {Crop} crop
 */
Vue.prototype.thumb = (image, width = 0, height = 0, crop = "") => {
  const result = `${window.PHP_THUMB_URL}?src=/${image.directory}/${image.filename}&w=${width}&h=${height}&zc=${crop}`;
  return result;
};
